export default __webpack_public_path__ + "static/media/male-avtar3.a3fd0269.svg";